import axios from "axios";

export async function getHome() {
    return await axios
        .get(`${process.env.REACT_APP_API_URL}getHome.php`)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            return {
                datas: [],
                album: []
            };
        });
}
